import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CharacterForm } from '@/forms/CharacterForm';
import { createCharacters } from '@/api/services/characters/createCharacters';
import type { CharacterFormState } from 'schemas';
import { ApiError } from '@/api/ApiError';
import { UNKNOWN_ERROR_API_ERROR } from '@/api/helpers/unknownError';
import { createCharacterPageMessages } from './createCharacterPage.messages.js';
import { ROUTES } from '@/routes';
import { DashboardPageContainer } from '@/components/layout/DashboardPageContainer';
import { toast } from 'sonner';

export function CreateCharacterPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<CharacterFormState[]>([
    {
      name: '',
      age: undefined,
      gender: undefined,
      reference_image: null,
    },
  ]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFormDataUpdate = (updatedFormData: CharacterFormState[]) => {
    setFormData(updatedFormData);
  };

  const handleSubmit = async (formData: CharacterFormState[]) => {
    setIsSubmitting(true);

    try {
      // Create the character using the createCharacters service
      const result = await createCharacters({ characters: formData });
      if (result) {
        navigate(ROUTES.DASHBOARD_CHARACTERS);
      }
    } catch (error) {
      const apiError =
        error instanceof ApiError ? error : UNKNOWN_ERROR_API_ERROR;
      toast.error(apiError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <DashboardPageContainer headline={createCharacterPageMessages.title}>
      <CharacterForm
        storyRoles={null}
        formData={formData}
        onFormDataUpdate={handleFormDataUpdate}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </DashboardPageContainer>
  );
}
